import { createContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './AppModal.css';

// DOM node of the header row next to the close button, for content (via a
// portal) to render into when the modal has no `header` prop. Stays hidden
// while empty.
export const AppModalHeaderSlot = createContext(null);

export default function AppModal({ visible, onHide, children, panelStyle, zIndex = 1200, header, footer }) {
    const [headerSlot, setHeaderSlot] = useState(null);

    useEffect(() => {
        if (!visible) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, [visible]);

    useEffect(() => {
        if (!visible) return;
        const onKey = (e) => { if (e.key === 'Escape') onHide?.(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [visible, onHide]);

    if (!visible) return null;

    return createPortal(
        <div className="app-modal-backdrop" style={{ zIndex }}>
            <div className="app-modal-panel applicantPopup" style={panelStyle}>
                {header ? (
                    <div className="app-modal-header">
                        <span className="app-modal-title">{header}</span>
                        <button className="app-modal-x" onClick={onHide}>✕</button>
                    </div>
                ) : (
                    <>
                        <div className="app-modal-header-slot" ref={setHeaderSlot} />
                        <button className="app-modal-x" onClick={onHide}>✕</button>
                    </>
                )}
                <div className="app-modal-body">
                    <AppModalHeaderSlot.Provider value={header ? null : headerSlot}>
                        {children}
                    </AppModalHeaderSlot.Provider>
                </div>
                {footer && (
                    <div className="app-modal-footer-bar">
                        {footer}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
}
